const REVALIDATION_MONTHS = 3;

/**
 * Returns true if the profile needs revalidation based on the
 * `last_data_updated_at` timestamp from the candidateInfo table.
 * Falls back to `updated_at` for backward compatibility with old records.
 *
 * Rules:
 *  - null / undefined / invalid date → revalidation required
 *  - ≥ REVALIDATION_MONTHS since last update → revalidation required
 *  - otherwise → not required
 */
export const isRevalidationRequired = (lastDataUpdatedAt) => {
    if (!lastDataUpdatedAt) return true;

    const lastUpdate = new Date(lastDataUpdatedAt);
    if (isNaN(lastUpdate.getTime())) return true;

    const now = new Date();
    const diffMonths =
        (now.getFullYear() - lastUpdate.getFullYear()) * 12 +
        (now.getMonth() - lastUpdate.getMonth());

    return diffMonths >= REVALIDATION_MONTHS;
};